<template>
  <header class="header box">
    <div class="header__left">
      <div class="header__photo">
        <img :src="profileImg" alt="profile.jpg" width="320" height="320" class="header__photo-img">
      </div>
      <div class="header__base-info">
        <h4 class="title title--h4">
          Prasham <span class="weight--400"> Tated </span>
        </h4>
        <div class="status">Senior DevOps Engineer | SRE | Cloud Architect</div>
        <ul class="header__social">
          <li>
            <a target="_blank" rel="noopener" href="https://linkedin.com/in/prashamtated" title="LinkedIn">
              <em class="font-icon icon-linkedin1"></em>
            </a>
          </li>
          <li>
            <a target="_blank" rel="noopener" href="https://github.com/prashamtated" title="Github">
              <em class="font-icon icon-github1"></em>
            </a>
          </li>
          <li>
            <a target="_blank" rel="noopener" href="https://www.instagram.com/_.prasham._/?hl=en" title="Instagram">
              <em class="font-icon icon-instagram1"></em>
            </a>
          </li>
          <li>
            <a target="_blank" rel="noopener" href="https://x.com/prashamtated" title="Twitter">
              <em class="font-icon icon-twitter1"></em>
            </a>
          </li>
          <li>
            <a target="_blank" rel="noopener" href="https://www.facebook.com/prashamtated1" title="Facebook">
              <em class="font-icon icon-facebook1"></em>
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="header__right">
      <ul class="header__contact">
        <li>
          <span class="overhead">Email</span>
          <a href="mailto:prashamtated@gmail.com" target="_blank" rel="noopener" title="Email" class="contact-link">
            <em class="font-icon icon-mail"></em>
            prashamtated@gmail.com
          </a>
        </li>
        <li>
          <span class="overhead">Location</span>
          <span class="contact-link">
            <em class="font-icon icon-compass"></em>
            Limassol, Cyprus
          </span>
        </li>
      </ul>
      <ul class="header__contact">
        <li>
          <span class="overhead">CV</span>
          <a :href="cvFile" download="Prasham_Tated_CV.pdf" title="Download CV" class="contact-link">
            <em class="font-icon icon-download"></em>
            Download CV
          </a>
        </li>
        <li>
          <span class="overhead">Phone</span>
          <a href="https://wa.me/35795910171" target="_blank" rel="noopener" title="WhatsApp +357" class="contact-link">
            <em class="font-icon icon-message-circle"></em>
            +357 95910171
          </a>
          <br>
          <a href="https://wa.me/919890492331" target="_blank" rel="noopener" title="WhatsApp +91" class="contact-link contact-link--secondary">
            <em class="font-icon icon-message-circle"></em>
            +91 9890492331
          </a>
        </li>
      </ul>
    </div>
  </header>
</template>

<script>
export default {
  name: 'HeaderCard',
  computed: {
    profileImg() {
      return require('@/assets/images/ProfilePhoto2025_highQuality.PNG')
    },
    cvFile() {
      return require('@/assets/resume/DevopsExpert_13Years_PrashamTated.pdf')
    }
  }
}
</script>

<style scoped>
.header__photo {
  width: 14rem !important;
  height: 14rem !important;
  border-radius: 3.5rem !important;
}
.header__photo-img {
  width: 100% !important;
  height: 100% !important;
  object-fit: cover;
  object-position: top center;
}
.contact-link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
}
.contact-link--secondary {
  margin-top: 4px;
}
</style>
